import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export default function PageHeader({ eyebrow, title, lead }) {
    return (
        <section className="relative pt-40 md:pt-48 pb-16 md:pb-24 bg-forest-900 border-b border-white/10 overflow-hidden">
            <div className="pointer-events-none absolute inset-0 opacity-[0.08]">
                <div className="mx-auto max-w-[1440px] h-full px-6 md:px-10 grid grid-cols-12">
                    {Array.from({ length: 12 }).map((_, i) => (
                        <div key={i} className="border-l border-ivory/30 h-full" />
                    ))}
                </div>
            </div>
            <div className="relative mx-auto max-w-[1440px] px-6 md:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9, ease: EASE }}
                    className="flex items-center gap-4 mb-8"
                >
                    <span className="h-px w-10 bg-lime" />
                    <span className="font-mono-mini text-[10px] tracking-[0.42em] uppercase text-lime">
                        {eyebrow}
                    </span>
                </motion.div>

                <h1 className="font-serif-display leading-[0.94] tracking-tighter text-[3rem] sm:text-[4.5rem] md:text-[6.2rem] lg:text-[7rem] text-ivory max-w-[16ch]">
                    <span className="mask-line">
                        <motion.span
                            initial={{ y: "110%" }}
                            animate={{ y: "0%" }}
                            transition={{ duration: 1.15, ease: EASE, delay: 0.2 }}
                        >
                            {title}
                        </motion.span>
                    </span>
                </h1>

                {lead && (
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1.1, ease: EASE, delay: 0.7 }}
                        className="mt-10 md:mt-14 max-w-2xl text-ivory/75 text-base md:text-[1.05rem] leading-relaxed"
                    >
                        {lead}
                    </motion.p>
                )}
            </div>
        </section>
    );
}
